<script>
import Layout from "../../layouts/main";
import appConfig from "@/app.config";
import GlobalEaring from "@/router/views/reporting/earning";
import ClientPerSupplier from "@/router/views/admin/clientpersupplier";
// import AccessHistory from "@/router/views/admin/accessHistory"; 
import OrdersStatus from "@/components/ordersStatus";


export default {
  page: {
    title: "Page d'Accueil",
    meta: [{ name: "description", content: appConfig.description }]
  },
  components: {
    Layout,
    GlobalEaring,
    ClientPerSupplier,
    // AccessHistory,
    OrdersStatus

  },

  data() {
    return {
      // firstDay:new Date(new Date().getFullYear(), new Date().getMonth(), 1),
      // lastDay:new Date(new Date().getFullYear(), new Date().getMonth() + 1, 0),
      firstDay:"",
      lastDay:"",

      }
  },

  created(){
      var date = new Date();
      this.firstDay = new Date(date.getFullYear(), date.getMonth(), 1);
      const startoffset = this.firstDay.getTimezoneOffset()
      this.firstDay= new Date(this.firstDay.getTime() - (startoffset*60*1000))
      this.firstDay=this.firstDay.toISOString().split('T')[0]

      this.lastDay = new Date(date.getFullYear(), date.getMonth() + 1, 0)
      const endoffset = this.lastDay.getTimezoneOffset()
      this.lastDay= new Date(this.lastDay.getTime() - (endoffset*60*1000))
      this.lastDay=this.lastDay.toISOString().split('T')[0]
  },

  methods:{
   
  },

};
</script>

<template>
  <Layout>
   
      <div class="row pt-4">
        <div class="col-lg-6" >
          <GlobalEaring :isMonthly="true" :currentMonth="new Date().getMonth()" :currentYear="new Date().getFullYear()"  />
        </div>

        <div class="col-lg-6" >
          <GlobalEaring :isYearly="true" :currentMonth="new Date().getMonth()" :currentYear="new Date().getFullYear()" />
        </div>
      </div>

      <div class="row">
        <div class="col-lg-6" >
          <ClientPerSupplier :firstDay=this.firstDay :lastDay=this.lastDay :isCurrentMonthProp=true :isCurrentMonthProp2=true :isListPerCustomer=true />
        </div>
        <div class="col-lg-6 pt-4 pt-lg-0" >
          <ClientPerSupplier :firstDay=this.firstDay :lastDay=this.lastDay :isCurrentMonthProp=true :isCurrentMonthProp2=true :isListPerSupplier=true />
        </div>
      </div>

      <div class="row mt-4 pb-4">
        <div class="col-12 ">
          <div class="card border border-light h-100  ">
            <div class="card-body p-0" >
              <OrdersStatus :firstDay=this.firstDay :lastDay=this.lastDay :isCurrentMonthProp=true  />
            </div>
          </div>
        </div>
      </div> 
      
    <!--   <div class="row m-3">
        <div class="col-lg-12">
            <div class="card">
              <div class="card-body">
                <h4 class="card-title mb-4">Historique de Connection</h4>
                  <div>
                    <b-table striped :items="items" :fields="fields"></b-table>
                  </div>
              </div>
            </div>
            </div>
    </div> -->
<!-- 
      <div class="row">
              <div class="col-sm-12" >
                <AccessHistory />
              </div>
      </div> -->
   

 
  </Layout>
</template> 

